import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  Input,
  Label,
  FormGroup,
  Form,
} from "reactstrap";
import { toast } from "react-toastify";
import { addCompany, getCompanyDataById, updateCompany } from "model/CompanyModel";

const CompanyAddEditModal = ({
  setCompanyAddEditModalOpen,
  companyAddEditModalOpen,
  getCompanyList,
  itemId,
}) => {
  const [formKey, setFormKey] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    status: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitCompany();
  };

  const closeModal = () => setCompanyAddEditModalOpen(false);
  const submitCompany = async () => {
    if (!formData?.name?.trim()) {
      toast.error("Name is required");
      return;
    }
    const payload = {
      name: formData?.name,
      title: formData?.name,
      status: formData?.status ? "active" : "deactive",
    };

    const response = itemId
      ? await updateCompany(itemId, payload)
      : await addCompany(payload);

    if (response?.success) {
      toast.success(response?.message || "Company saved successfully");
      getCompanyList?.();
      closeModal();
    } else {
      toast.error(response?.message || "Unable to save company");
    }
  };

  useEffect(() => {
    const getCompanyById = async () => {
      if (!itemId) {
        setFormData({ name: "", status: true });
        setFormKey((k) => k + 1);
        return;
      }
      const response = await getCompanyDataById({ Id: itemId });
      const row = response?.data;
      if (!row) return;

      setFormData({
        name: row?.name || row?.title || "",
        status: row?.status === true || row?.status === "active",
      });
      setFormKey((k) => k + 1);
    };
    getCompanyById();
  }, [itemId]);

  return (
    <Modal
    isOpen={companyAddEditModalOpen}
    toggle={closeModal}
      backdrop="static"
      className="modal-full-height"
      centered
    >
      <ModalBody key={formKey} className="p-4" style={{ maxHeight: "95vh", overflowY: "auto" }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold mb-0">Company</h5>
          <Button close onClick={closeModal} />
        </div>
        <hr />

        <Form onSubmit={handleSubmit}>
          {/* Name */}
          <FormGroup>
            <Label>Name</Label>
            <Input
              type="text"
              name="name"
              placeholder="Name"
              defaultValue={formData?.name}
              onChange={handleChange}
            />
          </FormGroup>

          <FormGroup>
            <Label>Status <span className="text-danger">*</span></Label>
            <div className="input-box d-flex align-items-center justify-content-between">
              <span className="text-muted">Type</span>
              <div className="d-flex align-items-center">
                <strong className="me-2">
                  {formData?.status ? "Active" : "Deactive"}
                </strong>
                <div className="form-switch">
                  <Input
                    type="switch"
                    name="status"
                    defaultChecked={formData?.status}
                    onChange={handleChange}
                    className="form-check-input-padding"
                  />
                </div>
              </div>
            </div>
          </FormGroup>

          <div className="text-end mt-3">
            <Button color="primary" type="submit">
              Save
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default CompanyAddEditModal;
